
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
import './registerServiceWorker'
import firebase from 'firebase/app'
import 'firebase/firestore'
import { firestorePlugin } from 'vuefire'
import VueAnalytics from 'vue-analytics'
import "firebase/analytics"
import AOS from 'aos'
import 'aos/dist/aos.css'
import LogRocket from 'logrocket';
LogRocket.init('2zl1iy/panneau-mobile');

Vue.use(firestorePlugin)

Vue.config.productionTip = false;
Vue.use(Argon);

Vue.use(VueAnalytics, {
  id: '274080597', router
});

firebase.initializeApp({
  apiKey: "AIzaSyCNzRhN6OtEg8pT43dyWhs0r1Bsvi15zXQ",
  authDomain: "panneaumobile.firebaseapp.com",
  databaseURL: "https://panneaumobile-default-rtdb.firebaseio.com",
  projectId: "panneaumobile",
  storageBucket: "panneaumobile.appspot.com",
  messagingSenderId: "1044643288808",
  appId: "1:1044643288808:web:3d1ea31676646b33f19b5d",
  measurementId: "G-E5NEFTEFMN"
})
firebase.analytics();

export const db = firebase.firestore()

new Vue({
  router,
  render: h => h(App),
  mounted () {
    AOS.init()
  }
}).$mount("#app");
